








import { defineComponent } from '~/utils/nuxt3-migration'
import { PropType } from 'vue'
import { Icon } from '~/models/icons/types'

export default defineComponent({
  props: {
    colspan: {
      type: [String, Number],
      default: null
    },
    icon: {
      type: Object as PropType<Icon>,
      default: null
    },
    variant: {
      type: String as PropType<'white' | 'secondary'>,
      default: 'white'
    }
  }
})
